var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.0002V13.4261C20 11.9592 18.9908 10.7266 17.625 10.3771M14.8542 1.06233C16.0147 1.52935 16.8334 2.66045 16.8334 3.98164C16.8334 5.30283 16.0147 6.43394 14.8542 6.90095M16.0417 15.0002C16.0417 13.5333 16.0417 12.7999 15.8006 12.2213C15.4792 11.45 14.8628 10.8371 14.0869 10.5176C13.5049 10.2779 12.7672 10.2779 11.2917 10.2779H8.91669C7.44121 10.2779 6.70346 10.2779 6.12152 10.5176C5.3456 10.8371 4.72913 11.45 4.40774 12.2213C4.16669 12.7999 4.16669 13.5333 4.16669 15.0002M13.2709 3.98164C13.2709 5.72032 11.8531 7.12979 10.1042 7.12979C8.35529 7.12979 6.93752 5.72032 6.93752 3.98164C6.93752 2.24297 8.35529 0.833496 10.1042 0.833496C11.8531 0.833496 13.2709 2.24297 13.2709 3.98164Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.833313 15.0002V13.4002C0.833313 11.9093 1.81391 10.6564 3.14101 10.3012M5.83331 0.833496C4.70569 1.30818 3.91024 2.45785 3.91024 3.80074C3.91024 5.14362 4.70569 6.29329 5.83331 6.76798",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsIcon);
export default __webpack_public_path__ + "static/media/groups-icon.de2c1f25e6dd11ba9779f6a46035e2bb.svg";
export { ForwardRef as ReactComponent };